import { NgModule } from '@angular/core';
import { MaterialModule } from '@material/material.module';
import { DashboardBarChartsComponent } from '@modules/reports/components/dashboard-bar-charts/dashboard-bar-charts.component';
import { DashboardFiltersComponent } from '@modules/reports/components/dashboard-filters/dashboard-filters.component';
import { DashboardJobItemComponent } from '@modules/reports/components/dashboard-job-item/dashboard-job-item.component';
import { ReferralReportsListItemComponent } from '@modules/reports/components/referral-report-list-item/referral-reports-list-item.component';
import { ReferralReportsListContainerComponent } from '@modules/reports/containers/referral-reports-list/referral-reports-list.container';
import { ReferralReportsEffects } from '@modules/reports/store/referral-reports.effects';
import { referralReportsReducer } from '@modules/reports/store/referral-reports.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@shared';
import { ReferralReportsService } from '@shared/services/referral-reports.service';
import { MojoBarChartModule } from 'mojo-bar-chart';
import { MojoCardModule } from 'mojo-card';
import { MojoExpandableCardModule } from 'mojo-expandable-card';
import { MojoPieChartModule } from 'mojo-pie-chart';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReferralReportsChartsComponent } from './components/referral-reports-charts/referral-reports-charts.component';
import { ReportsPageContainerComponent } from '@modules/reports/containers/reports-page/reports-page.container';
import { PipelinePageContainerComponent } from '@modules/reports/containers/pipeline/pipeline-page.container';
import { PipelineFiltersComponent } from '@modules/reports/components/pipeline-filters/pipeline-filters.component';
import { PipelineBarChartsComponent } from '@modules/reports/components/pipeline-bar-charts/pipeline-bar-charts.component';
import { PipelineJobsListComponent } from '@modules/reports/components/pipeline-jobs-list/pipeline-jobs-list.component';
import { PipelineJobItemComponent } from '@modules/reports/components/pipeline-job-item/pipeline-job-item.component';
import { MojoAvatarModule } from 'mojo-avatar';
import { JobItemModule } from '@shared/job-item/job-item.module';
import { PipelineTotalMatchesNumbersComponent } from '@modules/reports/components/pipeline-total-matches-numbers/pipeline-total-matches-numbers.component';
import { PipelineTotalDirectPerPhasesComponent } from '@modules/reports/components/pipeline-total-direct-per-phases/pipeline-total-direct-per-phases.component';
import { DashboardContainerComponent } from './containers/dashboard/dashboard.container';
import { DashboardJobsListComponent } from './components/dashboard-jobs-list/dashboard-jobs-list.component';
import { DashboardAverageResponseTimeComponent } from './components/dashboard-average-response-time/dashboard-average-response-time.component';
import { DashboardTotalMatchesNumbersComponent } from './components/dashboard-total-matches-numbers/dashboard-total-matches-numbers.component';
import { PieCharAverageComponent } from './components/pie-char-average/pie-char-average.component';
import { FunctionsAndDepartmentsFiltersComponent } from '@modules/reports/components/functions-and-departments-filters/functions-and-departments-filters.component';
import { ReportsJobListCommonComponent } from '@modules/reports/components/reports-job-list-common/reports-job-list-common.component';
import { ReportsJobItemCommonComponent } from '@modules/reports/components/reports-job-item-common/reports-job-item-common.component';

import { MojoFunnelChartModule } from 'mojo-funnel-chart';
import { DashboardAveragesComponent } from './components/dashboard-averages/dashboard-averages.component';
import { CandidateModule } from '@shared/candidate/candidate.module';
import { MojoAutocompleteModule } from 'mojo-autocomplete';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { ReportsJobsSearchWidgetComponent } from '@modules/reports/components/reports-jobs-search-widget/reports-jobs-search-widget.component';

@NgModule({
  imports: [
    StoreModule.forFeature('referralReportsPage', referralReportsReducer),
    EffectsModule.forFeature([ReferralReportsEffects]),
    SharedModule,
    MaterialModule,
    ReportsRoutingModule,
    MojoCardModule,
    MojoPieChartModule,
    MojoBarChartModule,
    MojoAvatarModule,
    JobItemModule,
    MojoFunnelChartModule,
    CandidateModule,
    MojoAutocompleteModule,
    MojoExpandableCardModule,
    MojoFeatureExtensionsModule,
  ],
  declarations: [
    ReferralReportsListContainerComponent,
    ReferralReportsListItemComponent,
    ReferralReportsChartsComponent,
    ReportsPageContainerComponent,
    PipelinePageContainerComponent,
    PipelineFiltersComponent,
    PipelineBarChartsComponent,
    PipelineJobsListComponent,
    PipelineJobItemComponent,
    PipelineTotalMatchesNumbersComponent,
    PipelineTotalDirectPerPhasesComponent,
    DashboardContainerComponent,
    DashboardFiltersComponent,
    DashboardBarChartsComponent,
    DashboardJobsListComponent,
    DashboardJobItemComponent,
    DashboardAverageResponseTimeComponent,
    DashboardTotalMatchesNumbersComponent,
    PieCharAverageComponent,
    FunctionsAndDepartmentsFiltersComponent,
    ReportsJobListCommonComponent,
    ReportsJobItemCommonComponent,
    DashboardAveragesComponent,
    ReportsJobsSearchWidgetComponent,
  ],
  providers: [ReferralReportsService],
})
export class ReportsModule {}
